module.exports = __webpack_public_path__ + "img/rainbow.bc0257a1.png";